<template>
  <div class="visit-page pb-3 mt-5 mb-5">
    <div class="container" v-html="page.content">
      <!-- <a class="visit-detail__link" href="/visits">
        <svg width="13" height="11" viewBox="0 0 13 11" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g clip-path="url(#clip0_323_2188)">
            <path d="M9.25 8.70832L6.33333 5.49999L9.25 2.29166" stroke="#7B7D93" stroke-linecap="round"
              stroke-linejoin="round" />
          </g>
          <g clip-path="url(#clip1_323_2188)">
            <path d="M6.25 8.70832L3.33333 5.49999L6.25 2.29166" stroke="#7B7D93" stroke-linecap="round"
              stroke-linejoin="round" />
          </g>
          <defs>
            <clipPath id="clip0_323_2188">
              <rect width="11" height="10" fill="white" transform="translate(13) rotate(90)" />
            </clipPath>
            <clipPath id="clip1_323_2188">
              <rect width="11" height="10" fill="white" transform="translate(10) rotate(90)" />
            </clipPath>
          </defs>
        </svg>
        Вернуться к списку поездок</a>
      <div class="visit-detail__title"> ТПП ООО &laquo;ЛЛК-ИНТЕРНЕШНЛ&raquo; Г. ПЕРМЬ </div>
      <div class="row visit-detail__container">
        <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 order-clg-2">
          <div class="visit-detail__block">
            <div class="visit-detail__block-title">
              Программа поездки
            </div>
            <div class="visit-detail__block-list-title">
              1 день
            </div>
            <ul class="visit-detail__block-list">
              <li>Прибытие в город </li>
              <li>Трансфер в отель</li>
              <li>Ужин</li>
              <li>Обзорная экскурсия по городу (опционально)</li>
              <li>Свободное время</li>
            </ul>
            <div class="visit-detail__block-list-title">
              2 день
            </div>
            <ul class="visit-detail__block-list">
              <li>Завтрак </li>
              <li>Трансфер на предприятие</li>
              <li>Экскурсия на предприятие</li>
              <li>Обед на предприятие</li>
              <li>Трансфер в аэропорт/отель</li>
              <li>Вылет</li>
            </ul>
          </div>
          <div class="visit-detail__block">
            <div class="visit-detail__block-title">
              Рекомендации по&nbsp;посещению производственной площадки
            </div>
            <div class="visit-detail__block-list-title">
              Порядок посещения
            </div>
            <ul class="visit-detail__block-list">
              <li>Заезд — не ранее 10:00 </li>
              <li>Выезд — не позднее 17:00</li>
            </ul>
            <div class="visit-detail__block-list-title">
              Предварительный план экскурсии по&nbsp;предприятию
            </div>
            <ul class="visit-detail__block-list">
              <li>Встреча группы</li>
              <li>Вводный инструктаж по технике безопасности</li>
              <li>Получение средств индивидуальной защиты</li>
              <li>Экскурсия по предприятию</li>
              <li>Конференц-зал — конференц-часть в зале завода, включающая общение с сотрудником предприятия в формате
                вопрос / ответ</li>
              <li>Обед</li>
              <li>Окончание экскурсии</li>
            </ul>
          </div>
          <div class="visit-detail__block-accordion">
            <div class="visit-detail__block-title" id='accordion'>Рекомендации по выбору отелей и трансфера
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M4 6L8 10L12 6" stroke="#D2233C" stroke-width="2" />
              </svg>
            </div>
            <div class="visit-detail">
              <div class="visit-detail__accordion-item">
                <div class="visit-detail__block-list-title">
                  Рекомендуемые отели, 4 звезды
                </div>
                <ul class="visit-detail__block-list">
                  <li><a class="visit__link" href="/">­«New Star»</a></li>
                  <li><a class="visit__link" href="/">«Aura City Hotel»</a></li>
                  <li><a class="visit__link" href="/">«Art Hotel»</a></li>
                  <li><a class="visit__link" href="/">«Apri Hotel»</a></li>
                </ul>
                <div class="visit-detail__description">
                  Средняя стоимость проживания- 5000 руб. (одноместное размещение)
                </div>
              </div>
              <div class="visit-detail__accordion-item">
                <div class="visit-detail__block-list-title">
                  Рекомендуемые рейсы
                </div>
                <div class='visit-detail__block-list-description'>МСК-Пермь</div>
                <ul class="visit-detail__block-list">
                  <li>­Рейс S7‑1157 (15:05- 19:10)</li>
                  <li>Рейс SU‑1768 (15:05- 19:20)</li>
                </ul>
                <div class='visit-detail__block-list-description'>Пермь-МСК</div>
                <ul class="visit-detail__block-list">
                  <li>­Рейс S7‑1158 (20:00-20:15)</li>
                  <li>Рейс SU‑1769 (20:20-20:35)</li>
                </ul>
                <div class="visit-detail__description">
                  Средняя стоимость билета, ручная кладь 10 кг- 4 000 руб.
                </div>
              </div>
              <div class="visit-detail__accordion-item">
                <div class="visit-detail__block-list-title">
                  Трансфер, экскурсия, ужин
                </div>
                <ul class="visit-detail__block-list">
                  <li>&shy;Стоимость трансфера Mercedes Sprinter, минимум &nbsp;часа&nbsp;&mdash; <bold>2500&nbsp;руб.
                    </bold>
                  </li>
                  <li>Обзорная групповая экскурсия, 2-3 часа&nbsp;&mdash; <bold>12&nbsp;000&nbsp;руб.</bold>
                  </li>
                  <li>Средний чек ужин в&nbsp;ресторане <bold>2500-3000 руб./чел </bold>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="visit-detail__block-table-description">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M10 5C9.73479 5 9.48043 5.10536 9.2929 5.29289C9.10536 5.48043 9 5.73478 9 6V10C9 10.2652 9.10536 10.5196 9.2929 10.7071C9.48043 10.8946 9.73479 11 10 11C10.2652 11 10.5196 10.8946 10.7071 10.7071C10.8946 10.5196 11 10.2652 11 10V6C11 5.73478 10.8946 5.48043 10.7071 5.29289C10.5196 5.10536 10.2652 5 10 5ZM10.92 13.62C10.8981 13.5563 10.8679 13.4957 10.83 13.44L10.71 13.29C10.5694 13.1512 10.3908 13.0572 10.1968 13.0199C10.0028 12.9825 9.80212 13.0034 9.62 13.08C9.49882 13.1306 9.38721 13.2017 9.29 13.29C9.19732 13.3834 9.124 13.4943 9.07423 13.6161C9.02447 13.7379 8.99924 13.8684 9 14C9.00159 14.1307 9.02876 14.2598 9.08 14.38C9.12492 14.5041 9.19657 14.6168 9.28989 14.7101C9.38321 14.8034 9.49591 14.8751 9.62 14.92C9.73971 14.9729 9.86913 15.0002 10 15.0002C10.1309 15.0002 10.2603 14.9729 10.38 14.92C10.5041 14.8751 10.6168 14.8034 10.7101 14.7101C10.8034 14.6168 10.8751 14.5041 10.92 14.38C10.9712 14.2598 10.9984 14.1307 11 14C11.0049 13.9334 11.0049 13.8666 11 13.8C10.9828 13.7362 10.9558 13.6755 10.92 13.62ZM10 0C8.02219 0 6.08879 0.58649 4.4443 1.6853C2.79981 2.78412 1.51809 4.3459 0.761209 6.17317C0.00433284 8.00043 -0.193701 10.0111 0.192152 11.9509C0.578004 13.8907 1.53041 15.6725 2.92894 17.0711C4.32746 18.4696 6.10929 19.422 8.0491 19.8079C9.98891 20.1937 11.9996 19.9957 13.8268 19.2388C15.6541 18.4819 17.2159 17.2002 18.3147 15.5557C19.4135 13.9112 20 11.9778 20 10C20 8.68678 19.7413 7.38642 19.2388 6.17317C18.7363 4.95991 17.9997 3.85752 17.0711 2.92893C16.1425 2.00035 15.0401 1.26375 13.8268 0.761205C12.6136 0.258658 11.3132 0 10 0ZM10 18C8.41775 18 6.87104 17.5308 5.55544 16.6518C4.23985 15.7727 3.21447 14.5233 2.60897 13.0615C2.00347 11.5997 1.84504 9.99113 2.15372 8.43928C2.4624 6.88743 3.22433 5.46197 4.34315 4.34315C5.46197 3.22433 6.88743 2.4624 8.43928 2.15372C9.99113 1.84504 11.5997 2.00346 13.0615 2.60896C14.5233 3.21447 15.7727 4.23984 16.6518 5.55544C17.5308 6.87103 18 8.41775 18 10C18 12.1217 17.1572 14.1566 15.6569 15.6569C14.1566 17.1571 12.1217 18 10 18Z"
                fill="#D2233C" />
            </svg>
            Экскурсия может быть отменена в связи с форс-мажором.
          </div>
          <div class="visit-detail__block-list-description">
            Более подробно с процессом организации поездки можно ознакомиться <a class="visit__link" href="/">здесь</a>
          </div>
          <div class="visit-detail__block">
            <a class="visit__item-button-detail" href="/">ОФОРМИТЬ ЗАЯВКУ </a>
          </div>
        </div>
        <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 order-clg-1">
          <div class="visit-detail__block">
            <div class="visit-detail__block-title">
              Средняя стоимость посещения
            </div>
            <div class="visit-detail__block-list-title">
              Базовая стоимость поездки
            </div>
            <div class="visit-detail__block-table">
              <div class="visit-detail__block-table-item">Размер группы</div>
              <div class="visit-detail__block-table-item">
                Стоимость экскурсии (включая НДС), руб.
              </div>
            </div>
            <div class="visit-detail__block-table">
              <div class="visit-detail__block-table-item">5 человек</div>
              <div class="visit-detail__block-table-item" style="justify-content: center;">
                170 000
              </div>
            </div>
            <div class="visit-detail__block-table">
              <div class="visit-detail__block-table-item">до 10 человек</div>
              <div class="visit-detail__block-table-item" style="justify-content: center;">
                230 000
              </div>
            </div>
            <div class="visit-detail__block-table">
              <div class="visit-detail__block-table-item">от 10 до 15 человек</div>
              <div class="visit-detail__block-table-item" style="justify-content: center;">
                310 000
              </div>
            </div>
            <div class="visit-detail__block-table">
              <div class="visit-detail__block-table-item">от 15 до 20 человек</div>
              <div class="visit-detail__block-table-item" style="justify-content: center;">
                380 000
              </div>
            </div>
          </div>
          <div class="visit-detail__block-table-description">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M10 5C9.73479 5 9.48043 5.10536 9.2929 5.29289C9.10536 5.48043 9 5.73478 9 6V10C9 10.2652 9.10536 10.5196 9.2929 10.7071C9.48043 10.8946 9.73479 11 10 11C10.2652 11 10.5196 10.8946 10.7071 10.7071C10.8946 10.5196 11 10.2652 11 10V6C11 5.73478 10.8946 5.48043 10.7071 5.29289C10.5196 5.10536 10.2652 5 10 5ZM10.92 13.62C10.8981 13.5563 10.8679 13.4957 10.83 13.44L10.71 13.29C10.5694 13.1512 10.3908 13.0572 10.1968 13.0199C10.0028 12.9825 9.80212 13.0034 9.62 13.08C9.49882 13.1306 9.38721 13.2017 9.29 13.29C9.19732 13.3834 9.124 13.4943 9.07423 13.6161C9.02447 13.7379 8.99924 13.8684 9 14C9.00159 14.1307 9.02876 14.2598 9.08 14.38C9.12492 14.5041 9.19657 14.6168 9.28989 14.7101C9.38321 14.8034 9.49591 14.8751 9.62 14.92C9.73971 14.9729 9.86913 15.0002 10 15.0002C10.1309 15.0002 10.2603 14.9729 10.38 14.92C10.5041 14.8751 10.6168 14.8034 10.7101 14.7101C10.8034 14.6168 10.8751 14.5041 10.92 14.38C10.9712 14.2598 10.9984 14.1307 11 14C11.0049 13.9334 11.0049 13.8666 11 13.8C10.9828 13.7362 10.9558 13.6755 10.92 13.62ZM10 0C8.02219 0 6.08879 0.58649 4.4443 1.6853C2.79981 2.78412 1.51809 4.3459 0.761209 6.17317C0.00433284 8.00043 -0.193701 10.0111 0.192152 11.9509C0.578004 13.8907 1.53041 15.6725 2.92894 17.0711C4.32746 18.4696 6.10929 19.422 8.0491 19.8079C9.98891 20.1937 11.9996 19.9957 13.8268 19.2388C15.6541 18.4819 17.2159 17.2002 18.3147 15.5557C19.4135 13.9112 20 11.9778 20 10C20 8.68678 19.7413 7.38642 19.2388 6.17317C18.7363 4.95991 17.9997 3.85752 17.0711 2.92893C16.1425 2.00035 15.0401 1.26375 13.8268 0.761205C12.6136 0.258658 11.3132 0 10 0ZM10 18C8.41775 18 6.87104 17.5308 5.55544 16.6518C4.23985 15.7727 3.21447 14.5233 2.60897 13.0615C2.00347 11.5997 1.84504 9.99113 2.15372 8.43928C2.4624 6.88743 3.22433 5.46197 4.34315 4.34315C5.46197 3.22433 6.88743 2.4624 8.43928 2.15372C9.99113 1.84504 11.5997 2.00346 13.0615 2.60896C14.5233 3.21447 15.7727 4.23984 16.6518 5.55544C17.5308 6.87103 18 8.41775 18 10C18 12.1217 17.1572 14.1566 15.6569 15.6569C14.1566 17.1571 12.1217 18 10 18Z"
                fill="#D2233C" />
            </svg>
            Организацией поездки дилер занимается самостоятельно.
          </div>
          <div class="visit-detail__block">
            <div class="visit-detail__block-list-title">
              Компенсация затрат
            </div>
            <div class="visit-detail__block-list-description">
              Стоимость экскурсии будет компенсирована ООО &laquo;ЛЛК-Интернешнл&raquo; (не&nbsp;более суммы указанной
              в&nbsp;таблице
              компенсаций) за&nbsp;счет списания маркетингового ретро бонуса при предоставлении подтверждающих
              документов.
            </div>
            <div class="visit-detail__block-list-description">
              В&nbsp;случае, если на&nbsp;балансе дилера недостаточно суммы ретро бонуса, поездку возможно организовать
              за&nbsp;свой счет, без списания баллов.
            </div>
          </div>
          <div class="visit-detail__block">
            <div class="visit-detail__block-list-title">
              Компенсации подлежат такие расходы
            </div>
            <div class="visit-detail__block-list-description">
              <div class="visit-detail__block-list-description-icon"> </div>
              <div class="visit-detail__block-list-description-items">
                Авиа/жд билеты (МСК-место назначения-МСК)
              </div>
            </div>
            <div class="visit-detail__block-list-description">
              <div class="visit-detail__block-list-description-icon"> </div>
              <div class="visit-detail__block-list-description-items">
                Проживание
              </div>
            </div>
            <div class="visit-detail__block-list-description">
              <div class="visit-detail__block-list-description-icon" > </div>
              <div class="visit-detail__block-list-description-items">
                Трансфер из/в аэропорт
              </div>
              <div class="visit-detail__block-list-description-text">
                В&nbsp;случае, если дилер добирается из&nbsp;соседнего региона, может быть компенсирована стоимость
                трансфера (при наличии подтверждающих документов)
              </div>
            </div>
            <div class="visit-detail__block-list-description">
              <div class="visit-detail__block-list-description-icon"> </div>
              <div class="visit-detail__block-list-description-items">
                Обед на производстве
              </div>
            </div>
            <div class="visit-detail__block-list-description">
              <div class="visit-detail__block-list-description-icon" > </div>
              <div class="visit-detail__block-list-description-items">
                Ужин
              </div>
            </div>
            <div class="visit-detail__block-list-description">
              <div class="visit-detail__block-list-description-icon" > </div>
              <div class="visit-detail__block-list-description-items">
                Экскурсионные услуги
              </div>
            </div>
            <div class="visit-detail__block-list-description">
              <div class="visit-detail__block-list-description-icon"> </div>
              <div class="visit-detail__block-list-description-items">
                Фотосъемка профессионального фотографа
              </div>
            </div>
          </div>
          <div class="visit-detail__block">
            <div class="visit-detail__description">
              <div class="visit-detail__block-list-title"> При бронировании даты и&nbsp;времени экскурсии, необходимо
                приобретать</div>
              <ul class="visit-detail__block-list">
                <li>Возвратные авиа/жд билеты</li>
                <li>Бронь гостиниц без штрафных санкций</li>
              </ul>
            </div>
          </div>
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
import { get } from "@/lib/axios";
import $ from "jquery";

export default {
  name: "PermPage",
  data: () => ( {
    type: 5,
    page: {},
  } ),
  methods: {
    async fetchData ()
    {
      await get( "static-page/" + this.type ).then( ( response ) =>
      {
        this.page = response.data.data;
      } );
      const accordion = document.getElementById( 'accordion' )
      accordion.addEventListener( 'click', function ( e )
      {
        this.classList.toggle( 'open' )
        const accordionItem = document.getElementsByClassName( 'visit-detail__block-accordion' )
        accordionItem[ 0 ].classList.toggle( 'open' )
      } )
      const that = this;
      $( "a.visit__item-button-detail" ).on( "click", ( e ) =>
      {
        e.preventDefault();
        that.$router.push( {
          name: "VisitRequestForm",
          params: {
            slug: "perm",
          },
        } );
      } );
    },
  },
  mounted ()
  {
    this.fetchData();
  },
  metaInfo ()
  {
    return {
      title: this.page.title + ` - ЛУКМАРКЕТ`,
    };
  },
};
</script>
